import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";

const useLanguage = () => {
  const { i18n } = useTranslation();
  const [currentLang, setCurrentLang] = useState(() => {
    return sessionStorage.getItem("lang") || "en";
  });

  const switchLanguage = (lang) => {
    moment.locale(lang);
    i18n.changeLanguage(lang);
    sessionStorage.setItem("lang", lang);
    setCurrentLang(lang);
  };

  const toggleLanguage = () => {
    const newLang = currentLang === "en" ? "es" : "en";
    switchLanguage(newLang);
  };

  useEffect(() => {
    switchLanguage(currentLang);
  }, [currentLang]);

  return { currentLang, switchLanguage, toggleLanguage };
};

export default useLanguage;
